import Vue from 'vue'
import Vuex from 'vuex'
import languageType from '@/locales/languageType'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: languageType.zh.code,
    currentApplyId: null,
    quickQueryApplyId: null
  },
  mutations: {
    CHANGE_LANGUAGE: (state, targetLanguage) => {
      state.lang = targetLanguage
    },
    SET_CURRENT_APPLY_ID: (state, applyId) => {
      state.currentApplyId = applyId
    },
    SET_QUICK_QUERY_APPLY_ID: (state, applyId) => {
      state.quickQueryApplyId = applyId
    }
  },
  actions: {
    changeLanguage ({ commit }, targetLanguage) {
      commit('CHANGE_LANGUAGE', targetLanguage)
    },
    setCurrentApplyId ({ commit }, applyId) {
      commit('SET_CURRENT_APPLY_ID', applyId)
    },
    removeCurrentApplyId ({ commit }) {
      commit('SET_CURRENT_APPLY_ID', null)
    },
    setQuickQueryApplyId ({ commit }, applyId) {
      commit('SET_QUICK_QUERY_APPLY_ID', applyId)
    },
    removeQuickApplyId ({ commit }) {
      commit('SET_QUICK_QUERY_APPLY_ID', null)
    }
  },
  modules: {},
  getters: {
    currentLanguage: state => {
      return state.lang
    },
    targetLanguage: state => {
      return state.lang === languageType.zh.code ? languageType.en : languageType.zh
    },
    currentApplyId: state => {
      return state.currentApplyId
    },
    quickQueryApplyId: state => {
      return state.quickQueryApplyId
    }
  }
})
